import { Button, Box, Card, CardActions, CardContent, Container, Typography } from "@mui/material";
import CelebrationIcon from '@mui/icons-material/Celebration';
import { Link } from "react-router-dom";
import { DateTime } from 'luxon';
import { useAuth } from "../../AuthContext";
import { useMemo } from "react";

export default function SubscribeCancelConfirm() {
  const auth = useAuth();
  
  const expireTime = useMemo(() => {
    if (auth.user.stripe.expiresAt) {
      return DateTime.fromISO(auth.user.stripe.expiresAt).toLocaleString(DateTime.DATE_FULL);
    }
    return 'Invalid Date';
  }, [auth.user?.stripe?.expiresAt]);

  return (
    <Container sx={{ p: 3 }} maxWidth="md">
      <Card>
        <CardContent sx={{ p: 4 }}>
          {/* <Box sx={{ textAlign: 'center' }}>
            <CelebrationIcon sx={{ fontSize: 72 }} color="success" />
          </Box> */}
          <Typography sx={{ textAlign: 'center', mt: 2 }} variant="h3">
            Are you sure?
          </Typography>
          <Typography sx={{ textAlign: 'center', mt: 2 }}>
          Are you sure you want to cancel OpenGolfSim Pro? Your subscription will be remain valid until {expireTime}
          </Typography>
        </CardContent>
        <CardActions sx={{ justifyContent: 'center' }}>
          <Button component={Link} to="/account/billing" color="secondary" variant="contained">Back to account</Button>
          <form method="POST" action="/api/subscriptions/cancel">
            <Button type="submit" color="primary" variant="contained">Yes, cancel my subscription</Button>
          </form>
        </CardActions>
      </Card>
    </Container>
  );
}